import { ProductUsageEnum } from "@shared/enums";
import { PRODUCT_USAGE_LABELS } from "@/scripts/constants/productUsageLabels";
import { CheckboxFilterElement } from "./checkboxFilter.element";

export class AbFilterUsageElement extends CheckboxFilterElement<ProductUsageEnum> {
  constructor() {
    super({ label: "Utilizzo", eventName: "usage-filter-change", optionLabel: (value) => PRODUCT_USAGE_LABELS[value] });
  }
}

export const defineAbFilterUsageElement = () => {
  if (!customElements.get("ab-filter-usage")) customElements.define("ab-filter-usage", AbFilterUsageElement);
};
